import { getAggregatorOrderStock } from "../services";

// TSK-3229: order-scoped, per-line stock + modifiability for the Aggregator
// screen, via getAggregatorOrderStock. Deliberately separate from
// PointOfSale/Core/stock.js, which is cart-shaped (BOM drawers, negative-stock
// config, batch consolidation) and not a fit here. Keyed by sOrderlineId, not
// productId — two lines can carry the same product and must be judged per line.
export const checkAggregatorItemsStock = async (tillId, sOrderId) => {
  if (!sOrderId) return { modifiable: "N", reason: null, stockMap: {} };

  try {
    const response = await getAggregatorOrderStock(tillId, sOrderId);
    const orderStock = response?.data?.data?.getAggregatorOrderStock;
    const items = orderStock?.items || [];
    const stockMap = {};
    items.forEach((it) => {
      stockMap[it.sOrderlineId] = {
        availabilityStatus: it.availabilityStatus,
        sellableQty: it.sellableQty,
        onhandQty: it.onhandQty,
      };
    });
    return {
      modifiable: orderStock?.modifiable || "N",
      reason: orderStock?.reason || null,
      stockMap,
    };
  } catch (error) {
    console.error("Error checking aggregator order stock:", error);
    return { modifiable: "N", reason: null, stockMap: {} };
  }
};

// TSK-4127: "Partial" used to be lumped into this (backend returns it as a
// distinct value, see AggregatorOrderStockItem.availabilityStatus), so this
// now means what it says — fully unavailable. Use isItemPartialStock or
// hasStockIssue below for the other two cases.
export const isItemOutOfStock = (item, stockMap) => {
  if (!item?.sOrderlineID) return false;
  const entry = stockMap?.[item.sOrderlineID];
  if (!entry) return false;
  return entry.availabilityStatus === "No";
};

// TSK-4127: enough stock for SOME of the ordered qty but not all of it — the
// case the partial-qty-edit flow exists for. Distinct from isItemOutOfStock
// so the two badges ("Out of Stock" vs "Partial Stock") don't collide.
export const isItemPartialStock = (item, stockMap) => {
  if (!item?.sOrderlineID) return false;
  const entry = stockMap?.[item.sOrderlineID];
  if (!entry) return false;
  return entry.availabilityStatus === "Partial";
};

// Anything that isn't fully sellable as ordered — used where callers
// previously relied on isItemOutOfStock also catching "Partial" (order-list
// attention badge, "still needs handling after a modification" checks).
export const hasStockIssue = (item, stockMap) => isItemOutOfStock(item, stockMap) || isItemPartialStock(item, stockMap);